// @flow

import { Grid } from 'semantic-ui-react';
import React from 'react';
import useIsAdmin from '@streaming-projects/useIsAdmin';
import { useFormikContext } from 'formik';
import { If } from '@presentational/If';
import { DISCOUNT_EXCEEDING_25_PERCENT_MESSAGE, IS_VBD_LIVE } from '@streaming-projects/constants';
import { StyledMessage } from '@src/common-utils/styledComponents';
import { checkIfGlobalDiscountExceedsThresholdForNonAdminWhenTouched } from '@streaming-projects/orgs/org-top-level/sp-custom-discounts/utils';
import { Spacer } from '@presentational/spacing/Spacer';
import { CommitGlobalDiscountLabelContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/global-discount/CommitGlobalDiscountLabelContainer';
import { CommitGlobalDiscountsTextFieldContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/global-discount/CommitGlobalDiscountsTextFieldContainer';
import { CommitGlobalDiscountsUpdateButtonContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/global-discount/CommitGlobalDiscountsUpdateButtonContainer';
import { CommitGlobalDiscountNoteContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/global-discount/CommitGlobalDiscountNoteContainer';
import { getIfVBDIsSupportedForRC } from '@src/configuration/custom-discounts';
import { VBDLegendContainer } from '@components/common/vbd/VBDLegendContainer';

export const CommitGlobalDiscountContainer = ({ readOnlyMode }) => {
  const isAdminUser = useIsAdmin();
  const formik = useFormikContext();
  const { values } = formik;
  const isVBDSupportedForThisRateCard = getIfVBDIsSupportedForRC(values);

  const doesDiscountExceedMaxThreshold =
    checkIfGlobalDiscountExceedsThresholdForNonAdminWhenTouched({
      isAdminUser,
      formik,
    });

  const errorMessage = doesDiscountExceedMaxThreshold
    ? DISCOUNT_EXCEEDING_25_PERCENT_MESSAGE
    : null;

  return (
    <>
      <Grid columns={4} stackable={true}>
        <Spacer y={12} />
        {/* { todo::SP restructure styling for label} */}
        <Grid.Column style={{ marginLeft: '-8px' }} textAlign="middle" width={2}>
          <CommitGlobalDiscountLabelContainer />
        </Grid.Column>
        <Grid.Column textAlign="middle" width={2}>
          <CommitGlobalDiscountsTextFieldContainer readOnlyMode={readOnlyMode} />
        </Grid.Column>
        <If test={doesDiscountExceedMaxThreshold}>
          <StyledMessage color="red" content={errorMessage} />
        </If>
        <Grid.Column textAlign="middle" width={1}>
          <CommitGlobalDiscountsUpdateButtonContainer
            disabled={doesDiscountExceedMaxThreshold}
            readOnlyMode={readOnlyMode}
          />
        </Grid.Column>
        <Grid.Column textAlign="middle" width={5}>
          <CommitGlobalDiscountNoteContainer />
        </Grid.Column>
      </Grid>
      <Spacer y={10} />
      <If test={IS_VBD_LIVE && isVBDSupportedForThisRateCard}>
        <VBDLegendContainer />
      </If>
    </>
  );
};
